import React from 'react';
import './DataHeaderSection.css';
import CharacterSelector from './CharacterSelector';
import BuildValidityIndicator from './BuildValidityIndicator';
import SpecialStatWidget from '../stats/SpecialStatWidget';

const DataHeaderSection = ({
    className = '',
    lang,
    build,
    setBuild,
    lvl,
    lvlStat,
    onLevelChange,
    isGenerationActive,
    canEditBuild = true,
    invalidBuildStatus = null,
}) => (
    <div className={`data-header-section column ${className}`.trim()}>
        {build && (
            <div className="data-header-section-row row">
                <CharacterSelector build={build} setBuild={setBuild} lang={lang} disabled={!canEditBuild || isGenerationActive} />
                {lvlStat && (
                    <SpecialStatWidget
                        lvl={lvl}
                        stat={lvlStat}
                        onDesiredValueChange={() => {}}
                        onLevelChange={onLevelChange}
                        lang={lang}
                        isGenerating={isGenerationActive || !canEditBuild}
                    />
                )}
                <BuildValidityIndicator status={invalidBuildStatus} />
            </div>
        )}
    </div>
);

export default DataHeaderSection;
